module.exports = __webpack_public_path__ + "static/media/cubes.53078eac.svg";